import { render, staticRenderFns } from "./FileX2Icon.vue?vue&type=template&id=248a88f8"
import script from "./FileX2Icon.vue?vue&type=script&lang=js"
export * from "./FileX2Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports